import { useQuery } from "@tanstack/react-query";
import cookiesHelper from "../../helpers/cookies";

import { IEmploymentIndustry } from "../../interfaces/services"

import api from "../../services";

const useGetEmploymentIndustries = () => {
    const queryFn = async (): Promise<IEmploymentIndustry[]> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`
        const res = await api.get('misc/employment-industries');
        return res.data;
    };

    return useQuery({
        queryKey: ['employment_industries'],
        queryFn,
    });
}

export default useGetEmploymentIndustries;